import {define, init, singleton} from '@injex/core';

export enum Theme {
    Dark = 'dark',
    Light = 'light',
    Auto = 'auto'
}

@define('themeManager')
@singleton()
export class ThemeManager {

    private _theme: Theme;

    @init()
    protected initialize() {
        const saved = localStorage.getItem('scheme') || localStorage.getItem('theme');
        this.setTheme(saved === Theme.Dark ? Theme.Dark : Theme.Light);
    }

    public get theme(): Theme {
        return this._theme;
    }

    public setTheme(theme: Theme = Theme.Light) {
        this._theme = theme === Theme.Dark ? Theme.Dark : Theme.Light;
        localStorage.setItem('theme', this._theme);
        localStorage.setItem('scheme', this._theme);
        document.documentElement.classList.toggle('dark', this._theme === Theme.Dark);
    }
}
